import { cva, type VariantProps } from 'class-variance-authority';
import classNames from '@utils/classnames';

/** Tinted, never loud. Text and icon share one hue with the background. */
export const alertVariants = cva('rounded-md px-3 py-2.5 text-sm', {
  variants: {
    type: {
      info: 'bg-info-subtle text-info-text',
      success: 'bg-positive-subtle text-positive-text',
      warning: 'bg-warning-subtle text-warning-text',
      error: 'bg-negative-subtle text-negative-text',
      neutral: 'bg-neutral-subtle text-fg-secondary',
    },
  },
  defaultVariants: {
    type: 'info',
  },
});

export interface AlertProps extends VariantProps<typeof alertVariants> {
  icon?: React.ReactNode;
  title?: string;
  children: React.ReactNode;
  className?: string;
}

export const Alert: React.FC<AlertProps> = ({ type, icon, title, children, className }) => {
  return (
    <div role="status" className={classNames(alertVariants({ type }), className)}>
      <div className="flex items-start gap-2.5">
        {icon && <div className="mt-px flex shrink-0 items-center [&>svg]:h-4 [&>svg]:w-4">{icon}</div>}
        <div className="min-w-0 flex-1">
          {title && <div className="font-semibold">{title}</div>}
          <div className={classNames({ 'mt-0.5': Boolean(title) })}>{children}</div>
        </div>
      </div>
    </div>
  );
};
